import { useEffect, useState } from 'react'

import { useSearchMyMonitoringAccounts, useSearchMyMonitoringAccountsCount } from '@apps-common/apis/portal/my-monitoring'
import { RootHeaderButtons } from '@apps-common/components/common'
import { Table } from '@apps-common/components/elements/table'
import { LayoutContainer, LayoutPadding } from '@apps-common/components/layout'
import { PageClearFilterButton, PageResultsCount } from '@apps-common/components/page'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { useMyMonitoringFilterStore } from '@apps-common/stores/useMyMonitoringFilterStore'
import { MyMonitoringHeader } from '../MyMonitoringHeader'
import { buildTableKeys } from './tableKeys'

export const MyMonitoringAccountTableView: React.FC = () => {
  const { navigateForward } = useNavigation()
  const filter = useMyMonitoringFilterStore()

  const [skip, setSkip] = useState<number>(0)
  const [take, setTake] = useState<number>(10)

  const {
    isLoading: countIsLoading,
    isError: countIsError,
    data: countData
  } = useSearchMyMonitoringAccountsCount({
    search: filter.search,
    take
  })

  const {
    isLoading: accountsIsLoading,
    isFetching: accountsIsFetching,
    isRefetching: accountsIsRefetching,
    isError: accountsIsError,
    data: accountsData
  } = useSearchMyMonitoringAccounts({
    search: filter.search,
    skip,
    take
  })

  useEffect(() => {
    const element = document.getElementById('my-monitoring-accounts-table-container')

    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }, [accountsIsLoading])

  const keys = buildTableKeys(navigateForward)

  const countLoading = countIsLoading || countIsError
  const loading = accountsIsLoading || accountsIsFetching || accountsIsRefetching || accountsIsError || countLoading

  return (
    <>
      <MyMonitoringHeader
        icons={<RootHeaderButtons />}
        leftComponent={<PageResultsCount loading={countLoading} count={countData} />}
        rightComponent={<PageClearFilterButton filter={filter} filterKeyWordsFunc={filter.getFilteredByKeywords} callback={filter.clear} />}
        loading={countLoading}
        navigateForward={navigateForward}
        searchCount={countData?.resultCount || -1}
      />
      <LayoutContainer id='my-monitoring-accounts-table-container'>
        <LayoutPadding topPadding='pt-[20px] md:pt-[20px]'>
          <Table
            loading={loading}
            loadingSkeletonHeight='leading-[32px]'
            placeholderSkeletonHeight='leading-[32px]'
            pagination={{
              loading,
              count: countData?.resultCount || 0,
              skip,
              take,
              onSkipChanged: (value: number) => setSkip(value),
              onTakeChanged: (value: number) => setTake(value)
            }}
            keys={keys}
            data={accountsData}
            onSkipChanged={(value: number) => setSkip(value)}
            onTakeChanged={(value: number) => setTake(value)}
          />
        </LayoutPadding>
      </LayoutContainer>
    </>
  )
}
